import AnimatedImage from './AnimatedImage'
export default AnimatedImage
